export default "__VITE_ASSET__BRPBGCpB__"